<ion-backdrop [visible]="true"></ion-backdrop>
<div class="container ion-padding">
  <ion-text class="title">
    {{ productList[selectedProductIndex]?.productName }}
    <ion-icon name="close-outline" class="close-icon" (click)="close()"></ion-icon>
  </ion-text>
  <ion-grid class="ion-no-padding ion-margin-top">
    <ion-row>
      <ion-col class="ion-no-padding section-col" size="5">
        <ion-row class="item-margin" *ngFor="let section of productList[selectedProductIndex]?.sections; let i = index">
          <ion-col class="section" [ngClass]="{'section-selected': selectedSectionIndex === i}" (click)="showSubSections(i, section, 'manual')">
            <ion-text class="section-name" [ngClass]="{'section-blue': section.isReactivePage}">{{ section.title }}</ion-text>
            @if (selectedSectionIndex === i && section.sections.length > 0) {
              <ion-icon name="chevron-forward-outline" class="right-arrow"></ion-icon>
            }
          </ion-col>
        </ion-row>
      </ion-col>
      <ion-col size="5">
        @if(!(subSections.length === 1 && subSections[0].title === '')) {
          <ion-row class="item-margin" *ngFor="let subSection of subSections; let j = index">
            <ion-col class="subsection" [ngClass]="{'subsection-selected': selectedSubSectionIndex === j}" (click)="selectSubSection(j)">
              <ion-text class="subsection-name" [innerHTML]="subSection.title"></ion-text>
            </ion-col>
          </ion-row>
        }
      </ion-col>
    </ion-row>
  </ion-grid>
  <app-section-buttons from="header" (selectedTypeChange)="showReferences(true)"></app-section-buttons>
  <app-reference [reference]="isReferences" showAllReferences="true" (showReferencesModal)="showReferences($event)"></app-reference>
</div>
